export const SwapIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Transger">
      <path
        id="Vector 81"
        d="M13.8022 17.7633H9.80217V20.3518C9.80217 20.5187 9.60983 20.6122 9.47861 20.5091L2.80217 15.2633L9.47861 10.0175C9.60983 9.91443 9.80217 10.0079 9.80217 10.1748V12.7633H15.8022"
        stroke="white"
        strokeWidth="2"
      />
      <path
        id="Vector 82"
        d="M11.8022 7.76331H15.8022V5.1748C15.8022 5.00791 15.9945 4.91443 16.1257 5.01753L22.8022 10.2633L16.1257 15.5091C15.9945 15.6122 15.8022 15.5187 15.8022 15.3518V12.7633H9.80217"
        stroke="white"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const PoolIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8022 4.76334L5.80217 7.76334L12.8022 10.7633L19.8022 7.76334L12.8022 4.76334Z"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.82762 10.8073L5.40825 11.8442C5.04057 12.0018 4.80217 12.3633 4.80217 12.7633C4.80217 13.1634 5.04057 13.5249 5.40825 13.6825L12.4083 16.6825C12.6598 16.7903 12.9445 16.7903 13.1961 16.6825L20.1961 13.6825C20.5638 13.5249 20.8022 13.1634 20.8022 12.7633C20.8022 12.3633 20.5638 12.0018 20.1961 11.8442L17.7767 10.8073L15.2381 11.8953L17.2636 12.7633L12.8022 14.6754L8.34076 12.7633L10.3662 11.8953L7.82762 10.8073Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.82762 15.8073L5.40825 16.8442C5.04057 17.0018 4.80217 17.3633 4.80217 17.7633C4.80217 18.1634 5.04057 18.5249 5.40825 18.6825L12.4083 21.6825C12.6598 21.7903 12.9445 21.7903 13.1961 21.6825L20.1961 18.6825C20.5638 18.5249 20.8022 18.1634 20.8022 17.7633C20.8022 17.3633 20.5638 17.0018 20.1961 16.8442L17.7767 15.8073L15.2381 16.8953L17.2636 17.7633L12.8022 19.6754L8.34076 17.7633L10.3662 16.8953L7.82762 15.8073Z"
      fill="white"
    />
  </svg>
);

export const TradeIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99997 3.72169V6.7217"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.99997 14.7217V17.7217"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="5.99997"
      y="6.72169"
      width="4"
      height="8"
      rx="0.8"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M16 7.72169V12.7217"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16 17.7217V20.7217"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="14"
      y="12.7217"
      width="4"
      height="5"
      rx="0.8"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const LiquidityIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1000003121">
      <g id="Group">
        <g id="bag-dollar--bag-payment-cash-money-finance">
          <g id="bag-dollar--bag-payment-cash-money-finance_2">
            <path
              id="Vector"
              d="M13.2087 21.1911C17.9971 21.1911 21.4173 19.4973 21.4173 15.7271C21.4173 11.629 19.3652 8.89701 15.2608 6.84799L16.8752 4.77165C16.9572 4.63542 17.0017 4.47997 17.0042 4.32103C17.0066 4.1621 16.9669 4.00535 16.8891 3.86667C16.8114 3.72798 16.6982 3.61229 16.5612 3.53133C16.4242 3.45037 16.2683 3.40701 16.1091 3.40564H10.3083C10.1491 3.40701 9.99307 3.45037 9.85608 3.53133C9.71908 3.61229 9.60596 3.72798 9.52818 3.86667C9.45039 4.00535 9.41072 4.1621 9.41317 4.32103C9.41562 4.47997 9.46009 4.63542 9.54211 4.77165L11.1565 6.86165C7.05214 8.92433 4.99997 11.6564 4.99997 15.7544C4.99997 19.4973 8.42026 21.1911 13.2087 21.1911Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector 3"
              d="M15.1009 12.0325C15.0358 11.8485 14.9354 11.6811 14.8078 11.5385C14.5364 11.2353 14.1421 11.0445 13.7031 11.0445H12.5559C11.8252 11.0445 11.2329 11.6368 11.2329 12.3675C11.2329 12.9892 11.6658 13.527 12.2732 13.6599L14.0198 14.042C14.7002 14.1908 15.1852 14.7938 15.1852 15.4903C15.1852 16.3089 14.5216 16.9731 13.7031 16.9731H12.715C12.0697 16.9731 11.5207 16.5606 11.3172 15.9849"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector 2489"
              d="M13.2088 11.0443V9.56212"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector 2490"
              d="M13.2088 18.4551V16.9729"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const FarmIcon = () => (
  <svg
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8382 24.0703H16.4171C18.1099 22.6821 19.0106 20.5588 18.8201 18.3655C18.7886 18.0025 18.5008 17.7147 18.1378 17.6831C16.3976 17.532 14.6877 18.068 13.3543 19.1644V15.377L11.8544 15.377V19.2655C10.5046 18.1011 8.74402 17.5275 6.9507 17.6832C6.58774 17.7147 6.29993 18.0025 6.26838 18.3655C6.07825 20.5554 6.97583 22.6798 8.67141 24.0703H6.37063C5.95644 24.0703 5.62062 24.4061 5.62062 24.8203C5.62062 25.2345 5.95644 25.5703 6.37063 25.5703H18.8381C19.2523 25.5703 19.5881 25.2345 19.5881 24.8203C19.5881 24.4061 19.2524 24.0703 18.8382 24.0703ZM17.3405 19.1628C17.2546 21.1809 15.9916 22.9525 14.1295 23.7006C14.0541 22.8444 13.8136 22.0155 13.4237 21.2571C14.3685 19.9679 15.8187 19.2275 17.3405 19.1628ZM7.74801 19.1628C10.4055 19.2759 12.5378 21.4075 12.651 24.0657C9.99358 23.9526 7.86121 21.8209 7.74801 19.1628Z"
      fill="white"
    />
    <path
      d="M15.6216 8.59898C15.6216 6.93533 14.2681 5.58179 12.6044 5.58179C10.9407 5.58179 9.58717 6.93527 9.58717 8.59898C9.58717 10.2627 10.9407 11.6162 12.6044 11.6162C14.2681 11.6162 15.6216 10.2626 15.6216 8.59898ZM11.266 8.59898C11.266 7.86107 11.8664 7.26066 12.6044 7.26066C13.3423 7.26066 13.9427 7.86101 13.9427 8.59898C13.9427 9.33695 13.3423 9.93731 12.6044 9.93731C11.8664 9.93731 11.266 9.3369 11.266 8.59898Z"
      fill="white"
    />
    <circle
      cx="12.6467"
      cy="8.59898"
      r="5.99322"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const BridgeIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.8354 7.43402L23.9045 6.50336V5.63859C23.9047 5.49383 23.8472 5.35526 23.745 5.25283C23.6428 5.1506 23.504 5.09329 23.3594 5.09329H22.2688C22.1243 5.09329 21.9855 5.1506 21.8833 5.25283C21.781 5.35526 21.7235 5.49383 21.7237 5.63859V6.56865C19.7656 9.91153 16.5169 11.9086 12.9999 11.9086C9.48295 11.9086 6.23432 9.91153 4.27616 6.56865V5.63859C4.27636 5.49383 4.21885 5.35526 4.11662 5.25283C4.01439 5.1506 3.87562 5.09329 3.73106 5.09329H2.64046C2.4959 5.09329 2.35713 5.1506 2.2549 5.25283C2.15266 5.35526 2.09516 5.49383 2.09536 5.63859V6.50336L1.1645 7.43402C1.02393 7.5712 0.967822 7.77326 1.01794 7.96335C1.06806 8.15324 1.21641 8.30159 1.4063 8.35171C1.59618 8.40163 1.79845 8.34572 1.93562 8.20495L2.09536 8.04521V19.8146C2.09516 19.9591 2.15266 20.0979 2.2549 20.2001C2.35713 20.3026 2.4959 20.3599 2.64046 20.3599H3.73106C3.87562 20.3599 4.01439 20.3026 4.11662 20.2001C4.21885 20.0979 4.27636 19.9591 4.27616 19.8146V18.1789H21.7237V19.8146C21.7235 19.9591 21.781 20.0979 21.8833 20.2001C21.9855 20.3026 22.1243 20.3599 22.2688 20.3599H23.3594C23.504 20.3599 23.6428 20.3026 23.745 20.2001C23.8472 20.0979 23.9047 19.9591 23.9045 19.8146V8.04521L24.0643 8.20495C24.2014 8.34572 24.4037 8.40163 24.5936 8.35171C24.7837 8.30159 24.932 8.15324 24.9819 7.96335C25.0321 7.77326 24.976 7.5712 24.8354 7.43402ZM17.907 11.7467V17.0885H15.1809V12.7419C16.131 12.5368 17.0483 12.2019 17.907 11.7467ZM14.0903 12.922V17.0885H11.9095V12.922C12.2713 12.9669 12.6353 12.9926 12.9999 12.9992C13.3645 12.9926 13.7285 12.9669 14.0903 12.922ZM10.8189 17.0885H8.09285V11.7467C8.95163 12.2019 9.86891 12.5368 10.8189 12.7419V17.0885ZM4.27616 8.50905C5.04409 9.5068 5.96397 10.3776 7.00245 11.0894V17.0885H4.27616V8.50905ZM18.9974 17.0885V11.0894C20.0359 10.3776 20.956 9.5068 21.7237 8.50905V17.0885H18.9974Z"
      fill="white"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Menu icn">
      <g id="icn">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6506 5.88556C12.734 5.88556 11.991 6.6286 11.991 7.5452C11.991 8.46179 12.734 9.20483 13.6506 9.20483C14.5672 9.20483 15.3102 8.46179 15.3102 7.5452C15.3102 6.6286 14.5672 5.88556 13.6506 5.88556ZM5.3528 7.5452C5.3528 6.62861 6.09584 5.88556 7.01243 5.88556C7.92902 5.88556 8.67207 6.62861 8.67207 7.5452C8.67207 8.46179 7.92902 9.20484 7.01243 9.20484C6.09584 9.20484 5.3528 8.46179 5.3528 7.5452ZM5.35246 14.1838C5.35246 13.2672 6.0955 12.5241 7.01209 12.5241C7.92868 12.5241 8.67173 13.2672 8.67173 14.1838C8.67173 15.1003 7.92868 15.8434 7.01209 15.8434C6.0955 15.8434 5.35246 15.1003 5.35246 14.1838ZM11.991 14.1838C11.991 13.2672 12.734 12.5241 13.6506 12.5241C14.5672 12.5241 15.3102 13.2672 15.3102 14.1838C15.3102 15.1003 14.5672 15.8434 13.6506 15.8434C12.734 15.8434 11.991 15.1003 11.991 14.1838ZM20.2893 5.88556C19.3727 5.88556 18.6296 6.6286 18.6296 7.5452C18.6296 8.46179 19.3727 9.20483 20.2893 9.20483C21.2059 9.20483 21.9489 8.46179 21.9489 7.5452C21.9489 6.6286 21.2059 5.88556 20.2893 5.88556ZM18.6296 14.1838C18.6296 13.2672 19.3727 12.5241 20.2893 12.5241C21.2059 12.5241 21.9489 13.2672 21.9489 14.1838C21.9489 15.1003 21.2059 15.8434 20.2893 15.8434C19.3727 15.8434 18.6296 15.1003 18.6296 14.1838ZM7.01209 19.1627C6.0955 19.1627 5.35246 19.9057 5.35246 20.8223C5.35246 21.7389 6.0955 22.4819 7.01209 22.4819C7.92868 22.4819 8.67173 21.7389 8.67173 20.8223C8.67173 19.9057 7.92868 19.1627 7.01209 19.1627ZM11.991 20.8223C11.991 19.9057 12.734 19.1627 13.6506 19.1627C14.5672 19.1627 15.3102 19.9057 15.3102 20.8223C15.3102 21.7389 14.5672 22.4819 13.6506 22.4819C12.734 22.4819 11.991 21.7389 11.991 20.8223ZM20.2893 19.1627C19.3727 19.1627 18.6296 19.9057 18.6296 20.8223C18.6296 21.7389 19.3727 22.4819 20.2893 22.4819C21.2059 22.4819 21.9489 21.7389 21.9489 20.8223C21.9489 19.9057 21.2059 19.1627 20.2893 19.1627Z"
          fill="#4D59FF"
        />
      </g>
    </g>
  </svg>
);

export const CurrencyEthereum = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.37305 10.7453L10.373 3.24527L15.373 10.7453M5.37305 10.7453L10.373 18.2453L15.373 10.7453M5.37305 10.7453L10.373 8.24527L15.373 10.7453M5.37305 10.7453L10.373 12.4119L15.373 10.7453"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SunIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" fill="#262626" />
    <path
      d="M13 18.8334C16.2217 18.8334 18.8334 16.2217 18.8334 13.0001C18.8334 9.77842 16.2217 7.16675 13 7.16675C9.77836 7.16675 7.16669 9.77842 7.16669 13.0001C7.16669 16.2217 9.77836 18.8334 13 18.8334Z"
      fill="#3EBD61"
    />
    <path
      d="M13 22.1333C12.5416 22.1333 12.1666 21.7916 12.1666 21.3333V21.2666C12.1666 20.8083 12.5416 20.4333 13 20.4333C13.4583 20.4333 13.8333 20.8083 13.8333 21.2666C13.8333 21.7249 13.4583 22.1333 13 22.1333ZM18.95 19.7833C18.7333 19.7833 18.525 19.6999 18.3583 19.5416L18.25 19.4333C17.925 19.1083 17.925 18.5833 18.25 18.2583C18.575 17.9333 19.1 17.9333 19.425 18.2583L19.5333 18.3666C19.8583 18.6916 19.8583 19.2166 19.5333 19.5416C19.375 19.6999 19.1666 19.7833 18.95 19.7833ZM7.04998 19.7833C6.83331 19.7833 6.62498 19.6999 6.45831 19.5416C6.13331 19.2166 6.13331 18.6916 6.45831 18.3666L6.56665 18.2583C6.89165 17.9333 7.41665 17.9333 7.74165 18.2583C8.06665 18.5833 8.06665 19.1083 7.74165 19.4333L7.63331 19.5416C7.47498 19.6999 7.25831 19.7833 7.04998 19.7833ZM21.3333 13.8333H21.2666C20.8083 13.8333 20.4333 13.4583 20.4333 12.9999C20.4333 12.5416 20.8083 12.1666 21.2666 12.1666C21.725 12.1666 22.1333 12.5416 22.1333 12.9999C22.1333 13.4583 21.7916 13.8333 21.3333 13.8333ZM4.73331 13.8333H4.66665C4.20831 13.8333 3.83331 13.4583 3.83331 12.9999C3.83331 12.5416 4.20831 12.1666 4.66665 12.1666C5.12498 12.1666 5.53331 12.5416 5.53331 12.9999C5.53331 13.4583 5.19165 13.8333 4.73331 13.8333ZM18.8416 7.99158C18.625 7.99158 18.4166 7.90825 18.25 7.74992C17.925 7.42492 17.925 6.89992 18.25 6.57492L18.3583 6.46659C18.6833 6.14159 19.2083 6.14159 19.5333 6.46659C19.8583 6.79158 19.8583 7.31659 19.5333 7.64159L19.425 7.74992C19.2666 7.90825 19.0583 7.99158 18.8416 7.99158ZM7.15831 7.99158C6.94165 7.99158 6.73331 7.90825 6.56665 7.74992L6.45831 7.63325C6.13331 7.30825 6.13331 6.78325 6.45831 6.45825C6.78331 6.13325 7.30831 6.13325 7.63331 6.45825L7.74165 6.56659C8.06665 6.89159 8.06665 7.41659 7.74165 7.74159C7.58331 7.90825 7.36665 7.99158 7.15831 7.99158ZM13 5.53325C12.5416 5.53325 12.1666 5.19159 12.1666 4.73325V4.66659C12.1666 4.20825 12.5416 3.83325 13 3.83325C13.4583 3.83325 13.8333 4.20825 13.8333 4.66659C13.8333 5.12492 13.4583 5.53325 13 5.53325Z"
      fill="#3EBD61"
    />
  </svg>
);

export const MoonIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" fill="#262626" />
    <path
      d="M19.8864 15.4526C19.7708 15.25 19.4458 14.9348 18.6367 15.0849C18.1889 15.1674 17.7338 15.205 17.2787 15.1824C15.5957 15.1074 14.0715 14.3045 13.0097 13.0663C12.0706 11.9782 11.4927 10.56 11.4855 9.02918C11.4855 8.17372 11.6444 7.34828 11.9695 6.56787C12.2873 5.80997 12.0634 5.41226 11.9045 5.24717C11.7383 5.07458 11.3483 4.83445 10.5826 5.16463C7.6282 6.45531 5.80066 9.53194 6.01737 12.8262C6.23407 15.9253 8.32887 18.5742 11.1027 19.5723C11.7672 19.8124 12.4679 19.955 13.1903 19.985C13.3058 19.9925 13.4214 20 13.537 20C15.9568 20 18.225 18.8144 19.6553 16.7958C20.1392 16.0979 20.0092 15.6552 19.8864 15.4526Z"
      fill="#3EBD61"
    />
  </svg>
);

export const WalletIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="61"
    height="61"
    viewBox="0 0 61 61"
    fill="none"
  >
    <path
      d="M35.9297 10.0671H24.6797C16.7247 10.0671 12.7473 10.0671 10.276 12.5777C7.80469 15.0882 7.80469 19.1288 7.80469 27.21V32.9243C7.80469 41.0055 7.80469 45.0461 10.276 47.5566C12.7473 50.0671 16.7247 50.0671 24.6797 50.0671H35.9297C43.8846 50.0671 47.8621 50.0671 50.3334 47.5566C52.8047 45.0461 52.8047 41.0055 52.8047 32.9243V27.21C52.8047 19.1288 52.8047 15.0882 50.3334 12.5777C47.8621 10.0671 43.8846 10.0671 35.9297 10.0671Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17.8047 20.0671H25.3047"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M37.8047 38.0671V32.0671C37.8047 31.1243 37.8047 30.6529 38.0976 30.36C38.3905 30.0671 38.8619 30.0671 39.8047 30.0671H50.8047C51.7475 30.0671 52.2189 30.0671 52.5118 30.36C52.8047 30.6529 52.8047 31.1243 52.8047 32.0671V38.0671C52.8047 39.0099 52.8047 39.4814 52.5118 39.7742C52.2189 40.0671 51.7475 40.0671 50.8047 40.0671H39.8047C38.8619 40.0671 38.3905 40.0671 38.0976 39.7742C37.8047 39.4814 37.8047 39.0099 37.8047 38.0671Z"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M22.6102 10.7415H21.8047V10.7H12.8047V14.7H18.4562C17.6317 17.0285 15.4162 18.7 12.8047 18.7C9.49119 18.7 6.80469 16.0135 6.80469 12.7C6.80469 9.38645 9.49119 6.69995 12.8047 6.69995C14.3342 6.69995 15.7257 7.27695 16.7852 8.21945L19.6137 5.39095C17.8277 3.72645 15.4387 2.69995 12.8047 2.69995C7.28219 2.69995 2.80469 7.17745 2.80469 12.7C2.80469 18.2225 7.28219 22.7 12.8047 22.7C18.3272 22.7 22.8047 18.2225 22.8047 12.7C22.8047 12.0295 22.7357 11.375 22.6102 10.7415Z"
      fill="#FFC107"
    />
    <path
      d="M3.95776 8.04545L7.24326 10.455C8.13226 8.25395 10.2853 6.69995 12.8048 6.69995C14.3343 6.69995 15.7258 7.27695 16.7853 8.21945L19.6138 5.39095C17.8278 3.72645 15.4388 2.69995 12.8048 2.69995C8.96376 2.69995 5.63276 4.86845 3.95776 8.04545Z"
      fill="#FF3D00"
    />
    <path
      d="M12.8046 22.6999C15.3876 22.6999 17.7346 21.7114 19.5091 20.1039L16.4141 17.4849C15.3764 18.2741 14.1083 18.701 12.8046 18.6999C10.2036 18.6999 7.9951 17.0414 7.1631 14.7269L3.9021 17.2394C5.5571 20.4779 8.9181 22.6999 12.8046 22.6999Z"
      fill="#4CAF50"
    />
    <path
      d="M22.6102 10.7415H21.8047V10.7H12.8047V14.7H18.4562C18.0618 15.8082 17.3514 16.7765 16.4127 17.4855L16.4142 17.4845L19.5092 20.1035C19.2902 20.3025 22.8047 17.7 22.8047 12.7C22.8047 12.0295 22.7357 11.375 22.6102 10.7415Z"
      fill="#1976D2"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.0165 14.6471C3.48779 13.6967 3.22343 13.2214 3.22343 12.7026C3.22343 12.1838 3.48779 11.7085 4.0165 10.7581L5.36575 8.33261L6.79167 5.95137C7.35042 5.01827 7.62979 4.55172 8.07912 4.2923C8.52845 4.03288 9.07219 4.02421 10.1596 4.00687L12.9348 3.96261L15.71 4.00687C16.7974 4.02421 17.3412 4.03288 17.7905 4.2923C18.2398 4.55172 18.5192 5.01827 19.078 5.95137L20.5039 8.33261L21.8531 10.7581C22.3818 11.7085 22.6462 12.1838 22.6462 12.7026C22.6462 13.2214 22.3818 13.6967 21.8531 14.6471L20.5039 17.0726L19.078 19.4538C18.5192 20.3869 18.2398 20.8535 17.7905 21.1129C17.3412 21.3723 16.7974 21.381 15.71 21.3983L12.9348 21.4426L10.1596 21.3983C9.07219 21.381 8.52845 21.3723 8.07912 21.1129C7.62979 20.8535 7.35042 20.3869 6.79167 19.4538L5.36575 17.0726L4.0165 14.6471Z"
      stroke="white"
      strokeWidth="2"
    />
    <circle cx="12.9348" cy="12.7026" r="3" stroke="white" strokeWidth="2" />
  </svg>
);

export const DownArrowIcon = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 6.77067L0 1.77067L1.16667 0.604004L5 4.43734L8.83333 0.604004L10 1.77067L5 6.77067Z"
      fill="#B4B4B4"
    />
  </svg>
);

export const DropUpswapIcon = () => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9351 11.2003L13.9351 15.2003L16.5236 15.2003C16.6905 15.2003 16.7839 15.3927 16.6808 15.5239L11.4351 22.2003L6.18929 15.5239C6.08618 15.3927 6.17967 15.2003 6.34655 15.2003L8.93506 15.2003L8.93506 9.20032"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M3.93506 13.2003L3.93506 9.20032L1.34655 9.20032C1.17966 9.20032 1.08618 9.00798 1.18929 8.87675L6.43506 2.20032L11.6808 8.87675C11.7839 9.00798 11.6905 9.20032 11.5236 9.20032L8.93506 9.20032L8.93506 15.2003"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const MaticIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_55_1340)">
      <path
        d="M15.6436 7.06074C15.2781 6.83477 14.8081 6.83477 14.3903 7.06074L11.4661 8.92497L9.48172 10.1113L6.60966 11.9755C6.24412 12.2015 5.77415 12.2015 5.3564 11.9755L3.11097 10.5067C2.74543 10.2808 2.48433 9.82884 2.48433 9.32041V6.49582C2.48433 6.04388 2.69321 5.59195 3.11097 5.30949L5.3564 3.89719C5.72193 3.67122 6.19191 3.67122 6.60966 3.89719L8.85509 5.36598C9.22063 5.59195 9.48172 6.04388 9.48172 6.55231V8.41654L11.4661 7.17372V5.25299C11.4661 4.80106 11.2572 4.34912 10.8394 4.06666L6.66188 1.41154C6.29634 1.18557 5.82637 1.18557 5.40862 1.41154L1.12663 4.12315C0.708877 4.34912 0.5 4.80106 0.5 5.25299V10.5632C0.5 11.0152 0.708877 11.4671 1.12663 11.7496L5.3564 14.4047C5.72193 14.6307 6.19191 14.6307 6.60966 14.4047L9.48172 12.5969L11.4661 11.3541L14.3381 9.54638C14.7037 9.32041 15.1736 9.32041 15.5914 9.54638L17.8368 10.9587C18.2023 11.1846 18.4634 11.6366 18.4634 12.145V14.9696C18.4634 15.4215 18.2546 15.8735 17.8368 16.1559L15.6436 17.5682C15.2781 17.7942 14.8081 17.7942 14.3903 17.5682L12.1449 16.1559C11.7794 15.93 11.5183 15.478 11.5183 14.9696V13.1619L9.53394 14.4047V16.2689C9.53394 16.7209 9.74282 17.1728 10.1606 17.4553L14.3903 20.1104C14.7559 20.3363 15.2258 20.3363 15.6436 20.1104L19.8734 17.4553C20.2389 17.2293 20.5 16.7774 20.5 16.2689V10.9022C20.5 10.4503 20.2911 9.99832 19.8734 9.71586L15.6436 7.06074Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_55_1340">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.279907)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MaticBlueIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2512_978)">
      <path
        d="M15.6436 7.52856C15.2781 7.30259 14.8081 7.30259 14.3903 7.52856L11.4661 9.39279L9.48172 10.5791L6.60966 12.4434C6.24412 12.6693 5.77415 12.6693 5.3564 12.4434L3.11097 10.9746C2.74543 10.7486 2.48433 10.2967 2.48433 9.78823V6.96364C2.48433 6.5117 2.69321 6.05976 3.11097 5.7773L5.3564 4.36501C5.72193 4.13904 6.19191 4.13904 6.60966 4.36501L8.85509 5.8338C9.22063 6.05976 9.48172 6.5117 9.48172 7.02013V8.88436L11.4661 7.64154V5.72081C11.4661 5.26888 11.2572 4.81694 10.8394 4.53448L6.66188 1.87936C6.29634 1.65339 5.82637 1.65339 5.40862 1.87936L1.12663 4.59097C0.708877 4.81694 0.5 5.26888 0.5 5.72081V11.0311C0.5 11.483 0.708877 11.9349 1.12663 12.2174L5.3564 14.8725C5.72193 15.0985 6.19191 15.0985 6.60966 14.8725L9.48172 13.0648L11.4661 11.8219L14.3381 10.0142C14.7037 9.78823 15.1736 9.78823 15.5914 10.0142L17.8368 11.4265C18.2023 11.6525 18.4634 12.1044 18.4634 12.6128V15.4374C18.4634 15.8894 18.2546 16.3413 17.8368 16.6238L15.6436 18.0361C15.2781 18.262 14.8081 18.262 14.3903 18.0361L12.1449 16.6238C11.7794 16.3978 11.5183 15.9459 11.5183 15.4374V13.6297L9.53394 14.8725V16.7367C9.53394 17.1887 9.74282 17.6406 10.1606 17.9231L14.3903 20.5782C14.7559 20.8042 15.2258 20.8042 15.6436 20.5782L19.8734 17.9231C20.2389 17.6971 20.5 17.2452 20.5 16.7367V11.37C20.5 10.9181 20.2911 10.4661 19.8734 10.1837L15.6436 7.52856Z"
        fill="#1258FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_2512_978">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.747681)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SideDot = () => (
  <svg
    width="17"
    height="26"
    viewBox="0 0 17 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_360_616)">
      <path
        d="M14.554 13.0833C14.554 20.4069 8.61702 26.3439 1.29337 26.3439C-6.03029 26.3439 -11.9673 20.4069 -11.9673 13.0833C-11.9673 5.7596 -6.03029 -0.177399 1.29337 -0.177399C8.61702 -0.177399 14.554 5.7596 14.554 13.0833Z"
        fill="url(#paint0_radial_360_616)"
      />
      <path
        d="M5.46886 13.7436C5.46886 16.3285 3.37345 18.4239 0.788629 18.4239C-1.79619 18.4239 -3.8916 16.3285 -3.8916 13.7436C-3.8916 11.1588 -1.79619 9.06342 0.788629 9.06342C3.37345 9.06342 5.46886 11.1588 5.46886 13.7436Z"
        fill="url(#paint1_linear_360_616)"
        stroke="url(#paint2_linear_360_616)"
        strokeWidth="0.780038"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_360_616"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.29337 13.3953) rotate(90) scale(11.6603)"
      >
        <stop stopColor="#4D59FF" />
        <stop offset="0.359424" stopColor="#4D59FF" stop-opacity="0.264719" />
        <stop offset="1" stopColor="#4D59FF" stop-opacity="0.01" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_360_616"
        x1="3.61295"
        y1="9.06342"
        x2="5.24343"
        y2="20.2168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8F5BFF" />
        <stop offset="1" stopColor="#0057FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_360_616"
        x1="-3.00295"
        y1="8.19083"
        x2="6.59762"
        y2="8.92334"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6C99" stop-opacity="0.19" />
        <stop offset="1" stopColor="#232049" />
      </linearGradient>
      <clipPath id="clip0_360_616">
        <rect
          width="17"
          height="26"
          fill="white"
          transform="translate(0 -0.00765991)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Chat = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 220 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
        fill="#1C98F7"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.925 160.359C116.763 160.023 121.559 159.241 126.253 158.022C132.045 159.789 138.168 160.19 144.141 159.191C144.378 159.152 144.617 159.134 144.856 159.136C146.987 159.136 149.786 160.373 153.862 162.986V158.689C153.863 157.945 154.062 157.216 154.437 156.574C154.813 155.933 155.353 155.403 156.001 155.038C157.774 154.034 159.424 152.879 160.93 151.608C166.87 146.575 170.225 139.865 170.225 132.756C170.225 130.371 169.847 128.054 169.132 125.84C170.926 122.492 172.377 118.972 173.443 115.321C176.888 120.484 178.734 126.549 178.75 132.756C178.75 142.416 174.254 151.422 166.478 158.008C165.18 159.107 163.814 160.122 162.388 161.047V171.091C162.388 174.549 158.4 176.536 155.588 174.481C152.929 172.493 150.176 170.635 147.338 168.912C146.525 168.425 145.68 167.996 144.808 167.626C142.471 167.977 140.078 168.156 137.665 168.156C127.958 168.156 118.993 165.248 111.932 160.359H111.925ZM60.5963 140.271C48.3313 129.869 41.25 115.699 41.25 100.513C41.25 69.4856 70.5237 44.6875 106.267 44.6875C142.017 44.6875 171.291 69.4856 171.291 100.513C171.291 131.546 142.01 156.344 106.267 156.344C102.252 156.344 98.2781 156.035 94.3869 155.416C92.7025 155.815 85.9719 159.816 76.2712 166.897C72.7581 169.469 67.7737 166.987 67.7737 162.663V145.53C65.2616 143.946 62.8633 142.189 60.5963 140.271ZM94.6206 144.849C94.9162 144.849 95.2187 144.87 95.5144 144.918C99.0206 145.509 102.623 145.812 106.267 145.812C136.462 145.812 160.628 125.338 160.628 100.513C160.628 75.6938 136.462 55.22 106.267 55.22C76.0856 55.22 51.9063 75.6938 51.9063 100.513C51.9063 112.516 57.5506 123.819 67.5331 132.275C70.0425 134.393 72.7994 136.318 75.7556 137.995C77.4125 138.93 78.4369 140.676 78.4369 142.56V152.439C86.1094 147.29 91.1556 144.849 94.6206 144.849ZM78.5537 111.052C73.8444 111.052 70.0287 107.271 70.0287 102.623C70.0287 97.9688 73.8444 94.1944 78.5537 94.1944C83.2631 94.1944 87.0788 97.9688 87.0788 102.623C87.0788 107.278 83.2631 111.052 78.5537 111.052ZM106.267 111.052C101.557 111.052 97.7419 107.271 97.7419 102.623C97.7419 97.9688 101.557 94.1944 106.267 94.1944C110.976 94.1944 114.792 97.9688 114.792 102.623C114.792 107.278 110.976 111.052 106.267 111.052ZM133.98 111.052C129.271 111.052 125.455 107.271 125.455 102.623C125.455 97.9688 129.271 94.1944 133.98 94.1944C138.689 94.1944 142.505 97.9688 142.505 102.623C142.505 107.278 138.689 111.052 133.98 111.052Z"
        fill="white"
      />
    </g>
  </svg>
);

export const Coin = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 220 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z"
        fill="#6CDE07"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.688 131.684C154.688 149.352 140.346 161.081 119.171 162.848V178.75H104.665V162.69C90.3422 161.075 76.7338 155.574 65.3125 146.781L75.9825 132.165C85.4906 139.556 94.49 144.375 105.332 145.984V114.496C80.9875 108.391 69.6506 99.5569 69.6506 81.4069C69.6506 64.0612 83.82 52.1744 104.665 50.5656V41.25H119.171V50.8888C130.509 52.1481 141.318 56.3581 150.521 63.0988L141.178 78.1962C133.842 72.8956 126.342 69.52 118.504 67.9181V98.4362C143.852 104.541 154.688 114.338 154.688 131.684ZM105.325 95.0606V66.7906C94.8269 67.595 89.3269 73.2188 89.3269 80.2863C89.3269 87.0238 92.4894 91.3688 105.332 95.0675L105.325 95.0606ZM135.011 132.804C135.011 125.586 131.505 121.247 118.504 117.549V146.63C129.009 145.819 135.011 140.518 135.011 132.811V132.804Z"
        fill="white"
      />
    </g>
  </svg>
);

export const Bitcoin = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 220 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="btc" clipPath="url(#clip0_108_3)">
      <path
        id="Vector"
        d="M220 110C220 131.756 213.549 153.023 201.462 171.113C189.375 189.202 172.195 203.301 152.095 211.627C131.995 219.952 109.878 222.131 88.5401 217.886C67.2022 213.642 47.6021 203.166 32.2183 187.782C16.8345 172.398 6.35804 152.798 2.11367 131.46C-2.13071 110.122 0.0476608 88.0047 8.3733 67.9048C16.6989 47.805 30.7979 30.6253 48.8873 18.5383C66.9767 6.45139 88.2441 0 110 0C139.174 0 167.153 11.5893 187.782 32.2183C208.411 52.8473 220 80.8262 220 110Z"
        fill="#F7931A"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.1801 50.2304L103.46 57.0004L109.11 35.9404L121.75 39.3704L116.32 59.5604L126.63 62.3304L132.07 41.9204L144.93 45.3604L139.39 65.8804C139.39 65.8804 160.39 70.5304 165.33 87.6104C170.27 104.69 154.47 113.66 149.59 114C149.59 114 167.99 124.09 161.67 143.94C155.35 163.79 135.95 167.34 115.54 162.79L110 184.07L97.1401 180.63L102.79 159.68L92.5901 156.9L86.9401 178L74.1801 174.57L79.8401 153.57L53.8901 146.57L60.4301 132.05C60.4301 132.05 67.7501 134.05 70.5201 134.71C73.2901 135.37 75.0701 132.49 75.8501 129.61C76.6301 126.73 88.3801 79.0004 89.4901 75.0704C90.6001 71.1404 90.1501 68.0704 85.4901 66.8604C80.8301 65.6504 74.4901 63.7604 74.4901 63.7604L78.1801 50.2304ZM103.68 113.44L96.6801 141.27C96.6801 141.27 131.39 153.8 135.83 136.17C140.27 118.54 103.68 113.44 103.68 113.44ZM106.9 100.24L113.77 74.7404C113.77 74.7404 143.49 80.0604 139.83 94.2504C136.17 108.44 118.65 103 106.9 100.24Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_3">
        <rect width="220" height="220" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Search_alt" opacity="0.6">
      <circle
        id="Ellipse 65"
        cx="11"
        cy="11"
        r="7"
        stroke="white"
        strokeWidth="2"
      />
      <path
        id="Ellipse 66"
        d="M11 8C10.606 8 10.2159 8.0776 9.85195 8.22836C9.48797 8.37913 9.15726 8.6001 8.87868 8.87868C8.6001 9.15726 8.37913 9.48797 8.22836 9.85195C8.0776 10.2159 8 10.606 8 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        id="Vector 109"
        d="M20 20L17 17"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
export const USDT = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      ></pattern>
    </defs>
  </svg>
);

export const BackArrowIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.6" cx="12.9348" cy="12.7026" r="12" fill="#D9D9D9" />
    <path
      d="M8.43481 12.7026L7.65395 12.0779L7.15419 12.7026L7.65395 13.3273L8.43481 12.7026ZM17.4348 13.7026C17.9871 13.7026 18.4348 13.2549 18.4348 12.7026C18.4348 12.1504 17.9871 11.7026 17.4348 11.7026V13.7026ZM11.6539 7.07794L7.65395 12.0779L9.21568 13.3273L13.2157 8.32733L11.6539 7.07794ZM7.65395 13.3273L11.6539 18.3273L13.2157 17.0779L9.21568 12.0779L7.65395 13.3273ZM8.43481 13.7026H17.4348V11.7026H8.43481V13.7026Z"
      fill="#141414"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.73901 1.91187L8.73901 16.9968"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M1.71851 8.93285L16.8035 8.93285"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="check">
      <path
        id="Vector"
        d="M4.1665 9.99992L8.33317 14.1666L16.6665 5.83325"
        stroke="url(#paint0_linear_114_2957)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_114_2957"
        x1="1.9777"
        y1="7.86017"
        x2="15.8946"
        y2="17.8458"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1122" stopColor="#835BFF" />
        <stop offset="1" stopColor="#3EBD61" />
      </linearGradient>
    </defs>
  </svg>
);

export const StarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="mi:favorite">
      <path
        id="Vector"
        d="M12 2.5C12.1857 2.5001 12.3677 2.55188 12.5256 2.64955C12.6835 2.74722 12.8111 2.88692 12.894 3.053L15.474 8.211L21.144 9.035C21.3287 9.06182 21.5023 9.1398 21.6449 9.2601C21.7876 9.38041 21.8938 9.53825 21.9514 9.71576C22.0091 9.89327 22.0159 10.0834 21.9711 10.2646C21.9263 10.4457 21.8317 10.6108 21.698 10.741L17.571 14.765L18.499 20.439C18.5289 20.6227 18.5068 20.811 18.4354 20.9829C18.3641 21.1547 18.2461 21.3032 18.0949 21.4117C17.9438 21.5202 17.7653 21.5843 17.5796 21.5969C17.394 21.6095 17.2085 21.5701 17.044 21.483L12 18.807L6.95605 21.483C6.79159 21.5701 6.60611 21.6095 6.42045 21.5969C6.23479 21.5843 6.05633 21.5202 5.90515 21.4117C5.75396 21.3032 5.63603 21.1547 5.56465 20.9829C5.49326 20.811 5.47123 20.6227 5.50105 20.439L6.42905 14.765L2.30205 10.741C2.16834 10.6108 2.07375 10.4457 2.02897 10.2646C1.98419 10.0834 1.991 9.89327 2.04865 9.71576C2.10629 9.53825 2.21246 9.38041 2.35515 9.2601C2.49784 9.1398 2.67135 9.06182 2.85605 9.035L8.52605 8.211L11.106 3.053C11.189 2.88692 11.3166 2.74722 11.4745 2.64955C11.6324 2.55188 11.8144 2.5001 12 2.5ZM12 5.736L10.082 9.572C10.0101 9.71626 9.90427 9.84099 9.77368 9.93553C9.64309 10.0301 9.49157 10.0917 9.33205 10.115L5.14805 10.723L8.19805 13.696C8.31331 13.8083 8.39977 13.9468 8.45008 14.0996C8.50039 14.2525 8.51307 14.4152 8.48705 14.574L7.80005 18.771L11.531 16.791C11.6755 16.7143 11.8365 16.6742 12 16.6742C12.1636 16.6742 12.3246 16.7143 12.469 16.791L16.2 18.771L15.513 14.574C15.4872 14.4154 15.5 14.2528 15.5503 14.1001C15.6006 13.9475 15.6869 13.8092 15.802 13.697L18.852 10.723L14.669 10.115C14.5095 10.0917 14.358 10.0301 14.2274 9.93553C14.0968 9.84099 13.991 9.71626 13.919 9.572L12 5.736Z"
        fill="white"
      />
    </g>
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.25 6L6.25 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 6L18.25 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 6H8.00667M7.33333 8H8V10.6667H8.66667M8 2C12.8 2 14 3.2 14 8C14 12.8 12.8 14 8 14C3.2 14 2 12.8 2 8C2 3.2 3.2 2 8 2Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIconFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 0.5C10.1857 0.500099 10.3677 0.551883 10.5256 0.649552C10.6835 0.747222 10.8111 0.886919 10.894 1.053L13.474 6.211L19.144 7.035C19.3287 7.06182 19.5023 7.1398 19.6449 7.2601C19.7876 7.38041 19.8938 7.53825 19.9514 7.71576C20.0091 7.89327 20.0159 8.08337 19.9711 8.26456C19.9263 8.44574 19.8317 8.61078 19.698 8.741L15.571 12.765L16.499 18.439C16.5289 18.6227 16.5068 18.811 16.4354 18.9829C16.3641 19.1547 16.2461 19.3032 16.0949 19.4117C15.9438 19.5202 15.7653 19.5843 15.5796 19.5969C15.394 19.6095 15.2085 19.5701 15.044 19.483L10 16.807L4.95605 19.483C4.79159 19.5701 4.60611 19.6095 4.42045 19.5969C4.23479 19.5843 4.05633 19.5202 3.90515 19.4117C3.75396 19.3032 3.63603 19.1547 3.56465 18.9829C3.49326 18.811 3.47123 18.6227 3.50105 18.439L4.42905 12.765L0.302046 8.741C0.168343 8.61078 0.0737497 8.44574 0.0289681 8.26456C-0.0158135 8.08337 -0.00899647 7.89327 0.0486481 7.71576C0.106293 7.53825 0.212464 7.38041 0.355151 7.2601C0.497838 7.1398 0.671346 7.06182 0.856046 7.035L6.52605 6.211L9.10605 1.053C9.18904 0.886919 9.31662 0.747222 9.47452 0.649552C9.63242 0.551883 9.81438 0.500099 10 0.5ZM10.5 11.5L8.08205 7.572C8.01006 7.71626 10.5996 11.3724 10.469 11.4669C10.3385 11.5615 10.6595 11.4767 10.5 11.5L6.19805 11.696C6.31331 11.8083 10.4837 11.3492 10.534 11.502C10.5843 11.6549 6.51307 12.4152 6.48705 12.574L10.534 11.502L9.53105 14.791C6.19805 11.696 10.3704 11.502 10.534 11.502C10.6975 11.502 10.3246 14.7143 10.469 14.791L10.5 11.5L13.513 12.574C13.4872 12.4154 10.4187 11.6196 10.469 11.4669C10.5194 11.3143 13.6869 11.8092 13.802 11.697L10.5 11.5L12.669 8.115C12.5095 8.09165 10.6646 11.5966 10.534 11.502C10.4034 11.4075 11.991 7.71626 11.919 7.572L10.5 11.5Z"
      fill="white"
    />
  </svg>
);

export const SignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g>
      <path
        d="M8.02344 18.9284C9.23959 19.6306 10.6191 20.0002 12.0234 20.0002C13.4277 20.0002 14.8073 19.6306 16.0234 18.9284C17.2396 18.2263 18.2495 17.2164 18.9516 16.0002C19.6538 14.7841 20.0234 13.4045 20.0234 12.0002C20.0234 10.596 19.6538 9.2164 18.9516 8.00024C18.2495 6.78409 17.2396 5.77419 16.0234 5.07204C14.8073 4.36989 13.4277 4.00024 12.0234 4.00024C10.6191 4.00024 9.23959 4.36989 8.02344 5.07204"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M2.02344 12.0002L1.24257 11.3755L0.742813 12.0002L1.24257 12.6249L2.02344 12.0002ZM11.0234 13.0002C11.5757 13.0002 12.0234 12.5525 12.0234 12.0002C12.0234 11.448 11.5757 11.0002 11.0234 11.0002V13.0002ZM5.24257 6.37555L1.24257 11.3755L2.80431 12.6249L6.80431 7.62494L5.24257 6.37555ZM1.24257 12.6249L5.24257 17.6249L6.80431 16.3755L2.80431 11.3755L1.24257 12.6249ZM2.02344 13.0002H11.0234V11.0002H2.02344V13.0002Z"
        fill="white"
      />
    </g>
  </svg>
);

export const LeftRightArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g>
      <path
        d="M13.9116 17.0027H9.91162V19.5912C9.91162 19.7581 9.71928 19.8516 9.58806 19.7485L2.91162 14.5027L9.58806 9.25691C9.71928 9.15381 9.91162 9.24729 9.91162 9.41418V12.0027H15.9116"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11.9116 7.00269H15.9116V4.41418C15.9116 4.24729 16.104 4.15381 16.2352 4.25691L22.9116 9.50269L16.2352 14.7485C16.104 14.8516 15.9116 14.7581 15.9116 14.5912V12.0027H9.91162"
        stroke="white"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const SettingSecIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M20.1784 14.0337L18.9428 13.0337C19.0013 12.6944 19.0315 12.3479 19.0315 12.0014C19.0315 11.655 19.0013 11.3085 18.9428 10.9692L20.1784 9.96916C20.2716 9.89363 20.3383 9.79304 20.3696 9.68075C20.4009 9.56846 20.3954 9.4498 20.3538 9.34055L20.3368 9.29412C19.9967 8.3941 19.4873 7.55977 18.8334 6.83145L18.7995 6.79394C18.7201 6.70564 18.6144 6.64216 18.4962 6.61187C18.378 6.58159 18.2529 6.58592 18.1373 6.62429L16.6037 7.1404C16.0378 6.70108 15.4059 6.35463 14.7231 6.11175L14.4269 4.59379C14.4046 4.47957 14.346 4.37449 14.2591 4.29252C14.1722 4.21054 14.061 4.15554 13.9402 4.13483L13.8893 4.1259C12.9065 3.95803 11.8728 3.95803 10.89 4.1259L10.8391 4.13483C10.7183 4.15554 10.6071 4.21054 10.5202 4.29252C10.4333 4.37449 10.3747 4.47957 10.3524 4.59379L10.0544 6.1189C9.37694 6.36182 8.74611 6.70809 8.18687 7.14397L6.64195 6.62429C6.52644 6.58561 6.40124 6.58113 6.28297 6.61143C6.1647 6.64173 6.05898 6.70539 5.97984 6.79394L5.94589 6.83145C5.29273 7.56029 4.78348 8.39448 4.44247 9.29412L4.42549 9.34055C4.34061 9.56378 4.4104 9.8138 4.60092 9.96916L5.85157 10.9799C5.79309 11.3157 5.7648 11.6586 5.7648 11.9997C5.7648 12.3425 5.79309 12.6854 5.85157 13.0194L4.60092 14.0302C4.50773 14.1057 4.44103 14.2063 4.40969 14.3186C4.37836 14.4309 4.38387 14.5495 4.42549 14.6588L4.44247 14.7052C4.7839 15.6053 5.28944 16.4357 5.94589 17.1679L5.97984 17.2054C6.05917 17.2937 6.1649 17.3572 6.2831 17.3875C6.40129 17.4177 6.52641 17.4134 6.64195 17.375L8.18687 16.8554C8.749 17.2929 9.37715 17.6393 10.0544 17.8804L10.3524 19.4055C10.3747 19.5198 10.4333 19.6248 10.5202 19.7068C10.6071 19.7888 10.7183 19.8438 10.8391 19.8645L10.89 19.8734C11.8818 20.0422 12.8975 20.0422 13.8893 19.8734L13.9402 19.8645C14.061 19.8438 14.1722 19.7888 14.2591 19.7068C14.346 19.6248 14.4046 19.5198 14.4269 19.4055L14.7231 17.8876C15.4056 17.6453 16.0411 17.2978 16.6037 16.8589L18.1373 17.375C18.2529 17.4137 18.3781 17.4182 18.4963 17.3879C18.6146 17.3576 18.7203 17.2939 18.7995 17.2054L18.8334 17.1679C19.4899 16.4339 19.9954 15.6053 20.3368 14.7052L20.3538 14.6588C20.4387 14.4391 20.3689 14.1891 20.1784 14.0337ZM17.6035 11.18C17.6507 11.4496 17.6752 11.7264 17.6752 12.0032C17.6752 12.28 17.6507 12.5568 17.6035 12.8265L17.479 13.5426L18.8881 14.6838C18.6745 15.1497 18.4049 15.5907 18.0845 15.9982L16.334 15.4106L15.7417 15.8714C15.2908 16.2214 14.7891 16.4964 14.2458 16.6893L13.5271 16.9446L13.1895 18.6769C12.6567 18.7341 12.1188 18.7341 11.5861 18.6769L11.2484 16.9411L10.5354 16.6821C9.99776 16.4893 9.49788 16.2142 9.05082 15.866L8.4585 15.4035L6.69665 15.9964C6.37598 15.5874 6.10811 15.1463 5.89307 14.682L7.31726 13.5301L7.19465 12.8158C7.14938 12.5497 7.12486 12.2747 7.12486 12.0032C7.12486 11.73 7.14749 11.4568 7.19465 11.1907L7.31726 10.4763L5.89307 9.32448C6.10623 8.85837 6.37598 8.41906 6.69665 8.0101L8.4585 8.603L9.05082 8.14047C9.49788 7.79223 9.99776 7.51721 10.5354 7.32434L11.2503 7.06896L11.588 5.33313C12.118 5.27598 12.6594 5.27598 13.1913 5.33313L13.529 7.06539L14.2477 7.32077C14.7891 7.51364 15.2927 7.78866 15.7436 8.13868L16.3359 8.59943L18.0864 8.01189C18.4071 8.42084 18.675 8.86194 18.89 9.32626L17.4809 10.4674L17.6035 11.18ZM12.3915 8.68157C10.558 8.68157 9.07157 10.0888 9.07157 11.8247C9.07157 13.5605 10.558 14.9677 12.3915 14.9677C14.2251 14.9677 15.7115 13.5605 15.7115 11.8247C15.7115 10.0888 14.2251 8.68157 12.3915 8.68157ZM13.8855 13.239C13.6896 13.4251 13.4567 13.5726 13.2003 13.6731C12.9439 13.7737 12.669 13.8252 12.3915 13.8248C11.8275 13.8248 11.2975 13.6158 10.8975 13.239C10.701 13.0535 10.5452 12.8331 10.439 12.5903C10.3328 12.3476 10.2784 12.0874 10.2788 11.8247C10.2788 11.2907 10.4995 10.7889 10.8975 10.4103C11.2975 10.0317 11.8275 9.82451 12.3915 9.82451C12.9556 9.82451 13.4856 10.0317 13.8855 10.4103C14.082 10.5958 14.2379 10.8162 14.3441 11.059C14.4502 11.3017 14.5047 11.5619 14.5042 11.8247C14.5042 12.3586 14.2835 12.8604 13.8855 13.239Z"
      fill="black"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M11.723 12.1739V5.65217C11.723 5.47921 11.7932 5.31332 11.9182 5.19102C12.0433 5.06871 12.2128 5 12.3896 5C12.5665 5 12.736 5.06871 12.8611 5.19102C12.9861 5.31332 13.0563 5.47921 13.0563 5.65217V12.1739C13.0563 12.3469 12.9861 12.5128 12.8611 12.6351C12.736 12.7574 12.5665 12.8261 12.3896 12.8261C12.2128 12.8261 12.0433 12.7574 11.9182 12.6351C11.7932 12.5128 11.723 12.3469 11.723 12.1739ZM16.7538 5.75815C16.6058 5.6666 16.4268 5.63574 16.2557 5.67223C16.0845 5.70872 15.9349 5.80964 15.8392 5.95316C15.7436 6.09668 15.7094 6.27128 15.7443 6.4392C15.7791 6.60713 15.8802 6.75489 16.0255 6.85054C17.9513 8.07908 19.0563 10.0193 19.0563 12.1739C19.0563 13.9036 18.3539 15.5624 17.1037 16.7855C15.8535 18.0085 14.1578 18.6957 12.3896 18.6957C10.6215 18.6957 8.92585 18.0085 7.6756 16.7855C6.42536 15.5624 5.72298 13.9036 5.72298 12.1739C5.72298 10.0193 6.82798 8.07908 8.75382 6.85054C8.89914 6.75489 9.00015 6.60713 9.035 6.4392C9.06985 6.27128 9.03574 6.09668 8.94005 5.95316C8.84436 5.80964 8.69477 5.70872 8.52363 5.67223C8.35249 5.63574 8.17355 5.6666 8.02548 5.75815C5.71465 7.23207 4.38965 9.57011 4.38965 12.1739C4.38965 14.2495 5.2325 16.2401 6.73279 17.7078C8.23309 19.1755 10.2679 20 12.3896 20C14.5114 20 16.5462 19.1755 18.0465 17.7078C19.5468 16.2401 20.3896 14.2495 20.3896 12.1739C20.3896 9.57011 19.0646 7.23207 16.7538 5.75815Z"
      fill="black"
    />
  </svg>
);

export const ATMCardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
  >
    <rect
      x="1.26465"
      y="1.27087"
      width="17.25"
      height="12.4583"
      rx="2"
      stroke="#33363F"
      strokeWidth="2"
    />
    <path
      d="M5.0979 9.89587H5.1079"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M2.2229 6.0625H18.5146"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ArrowdownIcon = () => (
  <svg
    fill="#ff1101"
    width="20px"
    height="20px"
    viewBox="0 0 24.00 24.00"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#ff1101"
    strokeWidth="0.00024000000000000003"
    transform="rotate(0)"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"></path>
    </g>
  </svg>
);

export const ArrowUpIcon = () => (
  <svg
    fill="#00e472"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z"></path>
    </g>
  </svg>
);

export const ArrowdownGrayIcon = () => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9021 1.83191L8.23543 8.49858L1.56877 1.83191"
      stroke="#ABABAB"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const InfoBlackIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.24023 13C8.69893 13 10.0979 12.4205 11.1293 11.3891C12.1608 10.3576 12.7402 8.95869 12.7402 7.5C12.7402 6.04131 12.1608 4.64236 11.1293 3.61091C10.0979 2.57946 8.69893 2 7.24023 2C5.78154 2 4.3826 2.57946 3.35115 3.61091C2.3197 4.64236 1.74023 6.04131 1.74023 7.5C1.74023 8.95869 2.3197 10.3576 3.35115 11.3891C4.3826 12.4205 5.78154 13 7.24023 13ZM7.24023 14.5C9.09675 14.5 10.8772 13.7625 12.19 12.4497C13.5027 11.137 14.2402 9.35652 14.2402 7.5C14.2402 5.64348 13.5027 3.86301 12.19 2.55025C10.8772 1.2375 9.09675 0.5 7.24023 0.5C5.38372 0.5 3.60324 1.2375 2.29049 2.55025C0.977732 3.86301 0.240234 5.64348 0.240234 7.5C0.240234 9.35652 0.977732 11.137 2.29049 12.4497C3.60324 13.7625 5.38372 14.5 7.24023 14.5ZM8.24023 5C8.24023 5.26522 8.13488 5.51957 7.94734 5.70711C7.7598 5.89464 7.50545 6 7.24023 6C6.97502 6 6.72066 5.89464 6.53313 5.70711C6.34559 5.51957 6.24023 5.26522 6.24023 5C6.24023 4.73478 6.34559 4.48043 6.53313 4.29289C6.72066 4.10536 6.97502 4 7.24023 4C7.50545 4 7.7598 4.10536 7.94734 4.29289C8.13488 4.48043 8.24023 4.73478 8.24023 5ZM7.99023 8C7.99023 7.80109 7.91122 7.61032 7.77056 7.46967C7.62991 7.32902 7.43915 7.25 7.24023 7.25C7.04132 7.25 6.85056 7.32902 6.7099 7.46967C6.56925 7.61032 6.49023 7.80109 6.49023 8V10.5C6.49023 10.6989 6.56925 10.8897 6.7099 11.0303C6.85056 11.171 7.04132 11.25 7.24023 11.25C7.43915 11.25 7.62991 11.171 7.77056 11.0303C7.91122 10.8897 7.99023 10.6989 7.99023 10.5V8Z"
      fill="black"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_867_1309)">
      <path
        d="M14.4113 14.323H3.21133V3.12295H7.21133V1.52295H3.21133C2.78698 1.52295 2.38002 1.69152 2.07996 1.99158C1.7799 2.29164 1.61133 2.6986 1.61133 3.12295V14.323C1.61133 14.7473 1.7799 15.1543 2.07996 15.4543C2.38002 15.7544 2.78698 15.923 3.21133 15.923H14.4113C14.8357 15.923 15.2426 15.7544 15.5427 15.4543C15.8428 15.1543 16.0113 14.7473 16.0113 14.323V10.323H14.4113V14.323Z"
        fill="#A1A1A1"
      />
      <path
        d="M9.61167 1.52295L12.2437 4.15495L7.65967 8.73895L8.79567 9.87495L13.3797 5.29095L16.0117 7.92295V1.52295H9.61167Z"
        fill="#A1A1A1"
      />
    </g>
    <defs>
      <clipPath id="clip0_867_1309">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.811523 0.723145)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RightArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
  >
    <path
      d="M9.99669 1.71777L15.83 7.7178M15.83 7.7178L9.99669 13.7178M15.83 7.7178H1.82999"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoRecordIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="file-times">
    <path
      fill="#6563FF"
      d="M14.71,12.29a1,1,0,0,0-1.42,0L12,13.59l-1.29-1.3a1,1,0,0,0-1.42,1.42L10.59,15l-1.3,1.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,16.41l1.29,1.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,15l1.3-1.29A1,1,0,0,0,14.71,12.29ZM20,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.1,0A1.1,1.1,0,0,0,13.06,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V9S20,9,20,8.94ZM14,5.41,16.59,8H15a1,1,0,0,1-1-1ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V7a3,3,0,0,0,3,3h3Z"
    ></path>
  </svg>
);
export const DropDownArrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/bold/arrow-down">
      <g id="arrow-down">
        <path
          id="Vector"
          d="M8.96036 6H5.84536H3.04036C2.56036 6 2.32036 6.58 2.66036 6.92L5.25036 9.51C5.66536 9.925 6.34036 9.925 6.75536 9.51L7.74036 8.525L9.34536 6.92C9.68036 6.58 9.44036 6 8.96036 6Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);
export const TrustCardOne = () => (
  <div>
    <svg
      width="428"
      height="201"
      viewBox="0 0 428 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="427"
        height="200"
        rx="19.5"
        fill="url(#paint0_linear_0_597)"
        stroke="url(#paint1_linear_0_597)"
      />
      <mask
        id="mask0_0_597"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="428"
        height="201"
      >
        <rect
          x="0.5"
          y="0.5"
          width="427"
          height="200"
          rx="19.5"
          fill="url(#paint2_linear_0_597)"
          stroke="url(#paint3_linear_0_597)"
        />
      </mask>
      <g mask="url(#mask0_0_597)">
        <path
          d="M428 201V42C392.904 94.4021 382.005 59.8494 339.598 59.8494C297.191 59.8494 298.543 98.883 245.464 107.447C192.386 116.011 201.539 90.2024 160.844 90.2024C120.148 90.2024 125.962 103.063 82.0368 111.539C38.1116 120.015 13.0626 107.339 0 116.508V201H428Z"
          fill="url(#paint4_linear_0_597)"
        />
        <path
          d="M0 115C13.0626 106.017 38.1116 118.436 82.0367 110.132C125.962 101.827 120.148 89.2269 160.844 89.2269C201.539 89.2269 192.386 114.513 245.464 106.123C298.543 97.7319 297.191 59.4882 339.598 59.4882C382.005 59.4882 392.904 93.3416 428 42"
          stroke="#3EBD61"
          strokeWidth="2"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_597"
          x1="214"
          y1="0"
          x2="214"
          y2="201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#141414" />
          <stop offset="1" stop-color="#070707" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_597"
          x1="214"
          y1="0"
          x2="214"
          y2="201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EBD61" />
          <stop offset="1" stop-color="#141414" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_0_597"
          x1="214"
          y1="0"
          x2="214"
          y2="201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#141414" />
          <stop offset="1" stop-color="#070707" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_0_597"
          x1="214"
          y1="0"
          x2="214"
          y2="201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EBD61" />
          <stop offset="1" stop-color="#141414" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_0_597"
          x1="200.969"
          y1="39.8463"
          x2="200.969"
          y2="201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EBD61" />
          <stop offset="1" stop-color="#121212" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);
export const Twitter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M22.9079 2.37988H27.1247L17.9121 12.9092L28.75 27.2373H20.264L13.6175 18.5474L6.01243 27.2373H1.79304L11.6468 15.975L1.25 2.37988H9.95139L15.9592 10.3228L22.9079 2.37988ZM21.4279 24.7134H23.7645L8.68174 4.7713H6.17433L21.4279 24.7134Z"
      fill="white"
    />
  </svg>
);
export const Telegram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <g clipPath="url(#clip0_0_821)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM15.5375 11.0737C14.0786 11.6805 11.1627 12.9365 6.78987 14.8417C6.07979 15.124 5.70782 15.4003 5.67396 15.6704C5.61673 16.1269 6.18839 16.3066 6.96684 16.5514C7.07273 16.5847 7.18244 16.6192 7.29492 16.6558C8.0608 16.9047 9.09103 17.196 9.62661 17.2075C10.1124 17.218 10.6547 17.0177 11.2533 16.6067C15.3389 13.8488 17.448 12.4548 17.5804 12.4247C17.6738 12.4035 17.8032 12.3769 17.891 12.4548C17.9787 12.5328 17.97 12.6804 17.9608 12.72C17.9041 12.9614 15.6602 15.0476 14.4989 16.1272C14.1369 16.4638 13.8801 16.7025 13.8276 16.757C13.71 16.8792 13.5902 16.9947 13.475 17.1058C12.7635 17.7917 12.2299 18.306 13.5045 19.146C14.1171 19.5496 14.6072 19.8834 15.0962 20.2164C15.6302 20.5801 16.1629 20.9428 16.852 21.3946C17.0276 21.5097 17.1953 21.6292 17.3586 21.7457C17.9801 22.1887 18.5384 22.5868 19.2282 22.5233C19.6291 22.4864 20.0431 22.1095 20.2533 20.9854C20.7503 18.3289 21.727 12.5731 21.9528 10.2012C21.9726 9.99341 21.9477 9.72746 21.9277 9.61072C21.9077 9.49397 21.866 9.32763 21.7142 9.2045C21.5345 9.05867 21.257 9.02792 21.133 9.0301C20.5688 9.04004 19.7032 9.34102 15.5375 11.0737Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_0_821">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const Linkedin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <g clipPath="url(#clip0_0_822)">
      <path
        d="M27.7793 0H2.21484C0.990234 0 0 0.966797 0 2.16211V27.832C0 29.0273 0.990234 30 2.21484 30H27.7793C29.0039 30 30 29.0273 30 27.8379V2.16211C30 0.966797 29.0039 0 27.7793 0ZM8.90039 25.5645H4.44727V11.2441H8.90039V25.5645ZM6.67383 9.29297C5.24414 9.29297 4.08984 8.13867 4.08984 6.71484C4.08984 5.29102 5.24414 4.13672 6.67383 4.13672C8.09766 4.13672 9.25195 5.29102 9.25195 6.71484C9.25195 8.13281 8.09766 9.29297 6.67383 9.29297ZM25.5645 25.5645H21.1172V18.6035C21.1172 16.9453 21.0879 14.8066 18.8027 14.8066C16.4883 14.8066 16.1367 16.6172 16.1367 18.4863V25.5645H11.6953V11.2441H15.9609V13.2012H16.0195C16.6113 12.0762 18.0645 10.8867 20.2266 10.8867C24.7324 10.8867 25.5645 13.8516 25.5645 17.707V25.5645Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_0_822">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const Instagram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <g clipPath="url(#clip0_0_823)">
      <path
        d="M15 2.70117C19.0078 2.70117 19.4824 2.71875 21.0586 2.78906C22.5234 2.85352 23.3145 3.09961 23.8418 3.30469C24.5391 3.57422 25.043 3.90234 25.5645 4.42383C26.0918 4.95117 26.4141 5.44922 26.6836 6.14648C26.8887 6.67383 27.1348 7.4707 27.1992 8.92969C27.2695 10.5117 27.2871 10.9863 27.2871 14.9883C27.2871 18.9961 27.2695 19.4707 27.1992 21.0469C27.1348 22.5117 26.8887 23.3027 26.6836 23.8301C26.4141 24.5273 26.0859 25.0313 25.5645 25.5527C25.0371 26.0801 24.5391 26.4023 23.8418 26.6719C23.3145 26.877 22.5176 27.123 21.0586 27.1875C19.4766 27.2578 19.002 27.2754 15 27.2754C10.9922 27.2754 10.5176 27.2578 8.94141 27.1875C7.47656 27.123 6.68555 26.877 6.1582 26.6719C5.46094 26.4023 4.95703 26.0742 4.43555 25.5527C3.9082 25.0254 3.58594 24.5273 3.31641 23.8301C3.11133 23.3027 2.86523 22.5059 2.80078 21.0469C2.73047 19.4648 2.71289 18.9902 2.71289 14.9883C2.71289 10.9805 2.73047 10.5059 2.80078 8.92969C2.86523 7.46484 3.11133 6.67383 3.31641 6.14648C3.58594 5.44922 3.91406 4.94531 4.43555 4.42383C4.96289 3.89648 5.46094 3.57422 6.1582 3.30469C6.68555 3.09961 7.48242 2.85352 8.94141 2.78906C10.5176 2.71875 10.9922 2.70117 15 2.70117ZM15 0C10.9277 0 10.418 0.0175781 8.81836 0.0878906C7.22461 0.158203 6.12891 0.416016 5.17969 0.785156C4.18945 1.17187 3.35156 1.68164 2.51953 2.51953C1.68164 3.35156 1.17188 4.18945 0.785156 5.17383C0.416016 6.12891 0.158203 7.21875 0.0878906 8.8125C0.0175781 10.418 0 10.9277 0 15C0 19.0723 0.0175781 19.582 0.0878906 21.1816C0.158203 22.7754 0.416016 23.8711 0.785156 24.8203C1.17188 25.8105 1.68164 26.6484 2.51953 27.4805C3.35156 28.3125 4.18945 28.8281 5.17383 29.209C6.12891 29.5781 7.21875 29.8359 8.8125 29.9062C10.4121 29.9766 10.9219 29.9941 14.9941 29.9941C19.0664 29.9941 19.5762 29.9766 21.1758 29.9062C22.7695 29.8359 23.8652 29.5781 24.8145 29.209C25.7988 28.8281 26.6367 28.3125 27.4688 27.4805C28.3008 26.6484 28.8164 25.8105 29.1973 24.8262C29.5664 23.8711 29.8242 22.7813 29.8945 21.1875C29.9648 19.5879 29.9824 19.0781 29.9824 15.0059C29.9824 10.9336 29.9648 10.4238 29.8945 8.82422C29.8242 7.23047 29.5664 6.13477 29.1973 5.18555C28.8281 4.18945 28.3184 3.35156 27.4805 2.51953C26.6484 1.6875 25.8105 1.17188 24.8262 0.791016C23.8711 0.421875 22.7813 0.164062 21.1875 0.09375C19.582 0.0175781 19.0723 0 15 0Z"
        fill="white"
      />
      <path
        d="M15 7.29492C10.7461 7.29492 7.29492 10.7461 7.29492 15C7.29492 19.2539 10.7461 22.7051 15 22.7051C19.2539 22.7051 22.7051 19.2539 22.7051 15C22.7051 10.7461 19.2539 7.29492 15 7.29492ZM15 19.998C12.2402 19.998 10.002 17.7598 10.002 15C10.002 12.2402 12.2402 10.002 15 10.002C17.7598 10.002 19.998 12.2402 19.998 15C19.998 17.7598 17.7598 19.998 15 19.998Z"
        fill="white"
      />
      <path
        d="M24.8086 6.99024C24.8086 7.98633 24 8.78907 23.0098 8.78907C22.0137 8.78907 21.2109 7.98047 21.2109 6.99024C21.2109 5.99414 22.0195 5.19141 23.0098 5.19141C24 5.19141 24.8086 6 24.8086 6.99024Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_0_823">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const Facebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <g clipPath="url(#clip0_0_824)">
      <path
        d="M15 0C6.7158 0 0 6.7158 0 15C0 22.0344 4.8432 27.9372 11.3766 29.5584V19.584H8.2836V15H11.3766V13.0248C11.3766 7.9194 13.6872 5.553 18.6996 5.553C19.65 5.553 21.2898 5.7396 21.9606 5.9256V10.0806C21.6066 10.0434 20.9916 10.0248 20.2278 10.0248C17.7684 10.0248 16.818 10.9566 16.818 13.3788V15H21.7176L20.8758 19.584H16.818V29.8902C24.2454 28.9932 30.0006 22.6692 30.0006 15C30 6.7158 23.2842 0 15 0Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_0_824">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ArrowdownFilledIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
      fill="white"
    />
    <path
      d="M12 15.0099C11.81 15.0099 11.62 14.9399 11.47 14.7899L7.94003 11.2599C7.65003 10.9699 7.65003 10.4899 7.94003 10.1999C8.23003 9.90992 8.71003 9.90992 9.00003 10.1999L12 13.1999L15 10.1999C15.29 9.90992 15.77 9.90992 16.06 10.1999C16.35 10.4899 16.35 10.9699 16.06 11.2599L12.53 14.7899C12.38 14.9399 12.19 15.0099 12 15.0099Z"
      fill="white"
    />
  </svg>
);
export const Menu = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M26.9834 3.33325H13.0167C6.95004 3.33325 3.33337 6.94992 3.33337 13.0166V26.9666C3.33337 33.0499 6.95004 36.6666 13.0167 36.6666H26.9667C33.0334 36.6666 36.65 33.0499 36.65 26.9833V13.0166C36.6667 6.94992 33.05 3.33325 26.9834 3.33325ZM28.3334 28.7499H11.6667C10.9834 28.7499 10.4167 28.1833 10.4167 27.4999C10.4167 26.8166 10.9834 26.2499 11.6667 26.2499H28.3334C29.0167 26.2499 29.5834 26.8166 29.5834 27.4999C29.5834 28.1833 29.0167 28.7499 28.3334 28.7499ZM28.3334 21.2499H11.6667C10.9834 21.2499 10.4167 20.6833 10.4167 19.9999C10.4167 19.3166 10.9834 18.7499 11.6667 18.7499H28.3334C29.0167 18.7499 29.5834 19.3166 29.5834 19.9999C29.5834 20.6833 29.0167 21.2499 28.3334 21.2499ZM28.3334 13.7499H11.6667C10.9834 13.7499 10.4167 13.1833 10.4167 12.4999C10.4167 11.8166 10.9834 11.2499 11.6667 11.2499H28.3334C29.0167 11.2499 29.5834 11.8166 29.5834 12.4999C29.5834 13.1833 29.0167 13.7499 28.3334 13.7499Z"
      fill="white"
    />
  </svg>
);
export const GasIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.75 11V2.5C1.75 1.5 2.42 1 3.25 1H7.25C8.08 1 8.75 1.5 8.75 2.5V11H1.75Z" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 11H9.5" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.195 5.00011H6.31C6.83 5.00011 7.255 4.75011 7.255 4.05511V3.44012C7.255 2.74512 6.83 2.49512 6.31 2.49512H4.195C3.675 2.49512 3.25 2.74512 3.25 3.44012V4.05511C3.25 4.75011 3.675 5.00011 4.195 5.00011Z" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.25 6.5H4.75" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 8.005L11 8V5L10 4.5" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const ClockIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 6C11 8.76 8.76 11 6 11C3.24 11 1 8.76 1 6C1 3.24 3.24 1 6 1C8.76 1 11 3.24 11 6Z" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.85445 7.58988L6.30445 6.66488C6.03445 6.50488 5.81445 6.11988 5.81445 5.80488V3.75488" stroke="#414141" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
